var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.582 0C3.203 0 0 4.356 0 7.946C0 9.681 0.187 11.328 1.224 12.71L7.092 20.618C7.107 20.637 7.13 20.645 7.146 20.663C7.20456 20.7302 7.27758 20.7832 7.35957 20.8181C7.44156 20.853 7.53039 20.8689 7.6194 20.8646C7.70841 20.8603 7.79529 20.8358 7.8735 20.7931C7.95171 20.7504 8.01924 20.6905 8.071 20.618C9.97625 18.0747 12.3284 15.318 14.1384 12.71C15.5 10.5 15.525 9.608 15.525 7.946C15.525 4.356 11.961 0 7.582 0ZM7.58 13.748C4.388 13.748 2.17 11.14 2.17 7.949C2.17 4.756 4.389 2.147 7.58 2.147C10.771 2.147 13.379 4.756 13.379 7.947C13.379 11.14 10.771 13.748 7.58 13.748Z",
    fill: "url(#paint0_linear_1_8699)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8699",
    x1: 0.000665452,
    y1: 9.12867,
    x2: 15.5255,
    y2: 9.12867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon-14.960da5f40574aaeee05789a708dff434.svg";
export { ForwardRef as ReactComponent };